import { BaseSearchParams } from '@/shared/entities';

export const LEAD_INDICATION_LIST_FIELDS = [
  'referringCompany',
  'cnpj',
  'indicatedAt',
  'indicatedBy',
  'actions',
] as const;

export type LeadIndicationListField = (typeof LEAD_INDICATION_LIST_FIELDS)[number];

export interface LeadIndication {
  id: string;
  referringCompany: string;
  cnpj: string;
  indicatedAt: string;
  indicatedBy: string;
  fileId?: string | null;
  fileCompanyId?: string | null;
}

export interface LeadIndicationListParams extends BaseSearchParams {
  sort?: LeadIndicationListField | `-${LeadIndicationListField}`;
}

export interface LeadIndicationListResponse {
  data: LeadIndication[];
  page?: number;
  pageSize?: number;
  total?: number;
  totalPages?: number;
}

export type LeadIndicationListSource = (
  params: LeadIndicationListParams,
  companyId: string,
) => Promise<LeadIndicationListResponse> | LeadIndicationListResponse;

export interface LeadIndicationError {
  code?: string;
  message: string;
  details?: unknown;
  status?: number;
}

const getRecord = (value: unknown): Record<string, unknown> | undefined => {
  if (typeof value !== 'object' || value === null) {
    return undefined;
  }

  return value as Record<string, unknown>;
};

export const mapLeadIndicationError = (
  error: unknown,
  fallbackMessage: string,
): LeadIndicationError => {
  const errorRecord = getRecord(error);
  const response = getRecord(errorRecord?.response);
  const responseData = getRecord(response?.data);

  return {
    code:
      typeof responseData?.code === 'string'
        ? responseData.code
        : typeof errorRecord?.code === 'string'
          ? errorRecord.code
          : undefined,
    message:
      typeof responseData?.message === 'string'
        ? responseData.message
        : typeof errorRecord?.message === 'string'
          ? errorRecord.message
          : fallbackMessage,
    details: responseData?.details,
    status: typeof response?.status === 'number' ? response.status : undefined,
  };
};
